/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Action } from '@ngrx/store';
import { IEcmDiagnosticError, IVehicleDiagnosticsResponse } from '../../models';

export enum EEcmPanelActionTypes {
  LoadDiagnosticsAction = '[EcmPanel] Load Diagnostics',
  LoadDiagnosticsSuccessAction = '[EcmPanel] Load Diagnostics Success',
  UpdateDiagnosticsAction = '[EcmPanel] Update Diagnostics',
  LoadDiagnosticsErrorAction = '[EcmPanel] Load Diagnostics Failure',
  CloseEcmPanelAction = '[EcmPanel] Close Ecm Panel'
}

export class LoadDiagnostics implements Action {
  public readonly type = EEcmPanelActionTypes.LoadDiagnosticsAction;

  constructor(public payload: { vehicleId: number }) {}
}

export class LoadDiagnosticsSuccess implements Action {
  public readonly type = EEcmPanelActionTypes.LoadDiagnosticsSuccessAction;

  constructor(public payload: IVehicleDiagnosticsResponse) {}
}

export class LoadDiagnosticsError implements Action {
  public readonly type = EEcmPanelActionTypes.LoadDiagnosticsErrorAction;

  constructor(public payload: { errors: IEcmDiagnosticError[] }) {}
}

/**
 * Updates the currently displayed diagnostics with fresh values (e.g. from the real-time socket feed),
 * without toggling the loading/error flags. The panel reads these via `getEcmPanelDiagnostics`.
 */
export class UpdateDiagnostics implements Action {
  public readonly type = EEcmPanelActionTypes.UpdateDiagnosticsAction;

  constructor(public payload: IVehicleDiagnosticsResponse) {}
}

/** Closes the ECM side panel and resets the slice back to its initial (CLOSED) state. */
export class CloseEcmPanel implements Action {
  public readonly type = EEcmPanelActionTypes.CloseEcmPanelAction;
}

export type EcmPanelActions = LoadDiagnostics | LoadDiagnosticsSuccess | LoadDiagnosticsError | UpdateDiagnostics | CloseEcmPanel;
